module.exports = __webpack_public_path__ + "static/media/aw.7f503ec4.svg";